import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconUsers';
/** Renders an SVG icon. */
const SvgUsers = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M21 23a5 5 0 0 0-10 0v.315c0 .378.307.685.685.685h8.63a.685.685 0 0 0 .685-.685zm2 .315A2.685 2.685 0 0 1 20.315 26h-8.63A2.685 2.685 0 0 1 9 23.315V23a7 7 0 1 1 14 0z"
      />
      <path
        fill="currentColor"
        d="M18 14a2 2 0 1 0-4 0 2 2 0 0 0 4 0m2 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0m10 5.315V18a6 6 0 0 0-6-6 1 1 0 1 0 0 2 4 4 0 0 1 4 4v1.315a.685.685 0 0 1-.685.685H25a1 1 0 1 0 0 2h2.315A2.685 2.685 0 0 0 30 19.315"
      />
      <path
        fill="currentColor"
        d="M22 10.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-2 0a3.5 3.5 0 1 0 7 0 3.5 3.5 0 0 0-7 0M2 19.315V18a6 6 0 0 1 6-6 1 1 0 1 1 0 2 4 4 0 0 0-4 4v1.315c0 .378.307.685.685.685H7a1 1 0 1 1 0 2H4.685A2.685 2.685 0 0 1 2 19.315"
      />
      <path
        fill="currentColor"
        d="M10 10.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m2 0a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
      />
    </svg>
  );
};
SvgUsers.displayName = displayName;
export default SvgUsers;
